import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule, CurrencyPipe, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";

import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { ActionButtonComponent } from "@hermes/aphrodite/action-button";
import { BackButtonComponent } from "@hermes/aphrodite/back-button";
import {
    CarouselComponent,
    CarouselPartDirective,
} from "@hermes/aphrodite/carousel";
import {
    ExpansionPanelComponent,
    ExpansionPanelPartDirective,
} from "@hermes/aphrodite/expansion-panel";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { OptionSelectorComponent } from "@hermes/aphrodite/option-selector";
import {
    CurrencyService,
    HermesCurrencyPipe,
    PriceComponent,
} from "@hermes/aphrodite/price";
import { SeparatorComponent } from "@hermes/aphrodite/separator";
import { StickyWrapperComponent } from "@hermes/aphrodite/sticky-wrapper";
import { registerSvgs, SvgIconComponent, svgPin } from "@hermes/aphrodite/svg";
import {
    TabItemComponent,
    TabListComponent,
    TabTitleDirective,
} from "@hermes/aphrodite/tab";
import { VideoComponent } from "@hermes/aphrodite/video";
import { CallToActionPurchaseModule } from "@hermes/fragments/call-to-action-purchase";
import { ImageResizerModule } from "@hermes/fragments/image-resizer";

import { PersonalizeLabelComponent } from "@hermes/fragments/personalize-label";

import { SpaceSeparatorPipeModule } from "@hermes/fragments/product-utils";
import { QuickBuyModalService } from "@hermes/fragments/quick-buy-modal";
import { ShadeFinderCallToActionComponent } from "@hermes/fragments/shade-finder-button";
import { StoryBehindModule } from "@hermes/fragments/story-behind";
import { VariantItemModule } from "@hermes/fragments/variant-item";
import { VtoCallToActionComponent } from "@hermes/fragments/vto-button";
import { SelectScrollAnimationModule } from "@hermes/select-scroll-animation";
import {
    ProductImageSeoUrlPipeModule,
    ProductPageFacade,
} from "@hermes/states/product-page";
import { SizeGuideTrayStateModule } from "@hermes/trays/size-guide";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { I18nAssetAttributeDirectiveModule } from "@hermes/utils-generic/i18n-asset-attribute";
import { SpacesAroundSlashesPipeModule } from "@hermes/utils-generic/pipes/spaces-around-slashes";
import { RouterServiceModule } from "@hermes/utils-generic/services/router";

import { CallToActionFindInStoreComponent } from "./components/call-to-action-find-in-store/call-to-action-find-in-store.component";
import { ImagesGalleryComponent } from "./components/images-gallery/images-gallery.component";
import { ProductInfoAttributesComponent } from "./components/product-info-attributes/product-info-attributes.component";
import { ProductInfoDescriptionComponent } from "./components/product-info-description/product-info-description.component";
import { ProductInfoFooterComponent } from "./components/product-info-footer/product-info-footer.component";
import { ProductInfoHeaderComponent } from "./components/product-info-header/product-info-header.component";
import { ProductPageCrossSellComponent } from "./components/product-page-cross-sell/product-page-cross-sell.component";
import { ProductPageGridComponent } from "./components/product-page-grid/product-page-grid.component";
import { ProductPageGridItemComponent } from "./components/product-page-grid-item/product-page-grid-item.component";
import { ProductTemplateComponent } from "./components/product-template/product-template.component";
import { ProductTogglesComponent } from "./components/product-toggles/product-toggles.component";
import { ProductVariantsComponent } from "./components/product-variants/product-variants.component";
import { SelectorTemplateComponent } from "./components/selector-template/selector-template.component";
import { SelectorTopLayerComponent } from "./components/selector-top-layer/selector-top-layer.component";
import { ShowMoreComponent } from "./components/show-more/show-more.component";
import { VariantTemplateComponent } from "./components/variant-template/variant-template.component";
import { DissolveOnTopDirective } from "./directives/dissolve-on-top-animation.directive";

@NgModule({
    imports: [
        ImageResizerModule,
        PersonalizeLabelComponent,
        PriceComponent,
        CommonModule,
        RouterServiceModule,
        SrOnlyNoSnippetDirective,
        CarouselComponent,
        CarouselPartDirective,
        VtoCallToActionComponent,
        ShadeFinderCallToActionComponent,
        CommonModule,
        BackButtonComponent,
        StoryBehindModule,
        ProductImageSeoUrlPipeModule,
        I18nAssetAttributeDirectiveModule,
        SvgIconComponent,
        VideoComponent,
        ExpansionPanelComponent,
        ExpansionPanelPartDirective,
        TranslateModule,
        SpaceSeparatorPipeModule,
        NgOptimizedImage,
        SpacesAroundSlashesPipeModule,
        ReactiveFormsModule,
        VariantItemModule,
        SizeGuideTrayStateModule,
        CallToActionPurchaseModule,
        ActionButtonComponent,
        MessageBlockComponent,
        StickyWrapperComponent,
        SeparatorComponent,
        OptionSelectorComponent,
        TabListComponent,
        TabItemComponent,
        DissolveOnTopDirective,
        A11yModule,
        TabTitleDirective,
        SelectScrollAnimationModule,
    ],
    providers: [
        ProductPageFacade,
        QuickBuyModalService,
        HermesCurrencyPipe,
        CurrencyPipe,
        CurrencyService,
    ],
    declarations: [
        VariantTemplateComponent,
        ShowMoreComponent,
        CallToActionFindInStoreComponent,
        SelectorTopLayerComponent,
        ProductVariantsComponent,
        SelectorTemplateComponent,
        ProductPageGridItemComponent,
        ProductPageGridComponent,
        ProductPageCrossSellComponent,
        ProductTemplateComponent,
        ProductTogglesComponent,
        ProductInfoFooterComponent,
        ProductInfoAttributesComponent,
        ProductInfoDescriptionComponent,
        ProductInfoHeaderComponent,
        ImagesGalleryComponent,
    ],
    exports: [
        CallToActionFindInStoreComponent,
        ProductPageGridItemComponent,
        ProductPageGridComponent,
        ProductPageCrossSellComponent,
        ProductTogglesComponent,
        ProductInfoFooterComponent,
        ProductInfoAttributesComponent,
        ProductInfoDescriptionComponent,
        ProductInfoHeaderComponent,
        ProductTemplateComponent,
        ProductVariantsComponent,
        ImagesGalleryComponent,
        DissolveOnTopDirective,
        ShowMoreComponent,
    ],
})
export class ProductPageModule {
    constructor() {
        registerSvgs([svgPin]);
    }
}
